import React, { ReactElement } from "react";
import styles from "./PrimaryButton.module.scss";
import { Button } from "semantic-ui-react";
import { SemanticSIZES } from "semantic-ui-react/dist/commonjs/generic";

type Props = {
  text?: string | ReactElement;
  children?: string | ReactElement;
  role?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  size?: SemanticSIZES;
  className?: string;
};

const PrimaryButton = ({
  text,
  role = "button",
  onClick,
  children,
  disabled = false,
  size,
  className,
}: Props) => {
  return (
    <Button
      onClick={onClick}
      primary={true}
      fluid
      role={role}
      className={`${styles.self} ${className ?? ""}`}
      disabled={disabled}
      size={size}
    >
      {children || text}
    </Button>
  );
};

export default PrimaryButton;
